/**
 * Travel Assistant Repository Factory
 *
 * Factory Pattern: Creates configured repository instances
 * Dependency Inversion: Provides abstraction for repository creation
 */

import { ITravelAssistantRepository } from '../interfaces/ITravelAssistantRepository';
import { TravelAssistantRepository } from '../repositories/TravelAssistantRepository';
import { AxiosHttpClient } from '../implementations/AxiosHttpClient';

export class TravelAssistantRepositoryFactory {
  private static instance: ITravelAssistantRepository | null = null;

  /**
   * Get or create a singleton instance of TravelAssistantRepository
   */
  static getInstance(): ITravelAssistantRepository {
    if (!this.instance) {
      const baseUrl = process.env.NEXT_PUBLIC_CONCIERGE_API_URL;
      if (!baseUrl) {
        throw new Error(
          'NEXT_PUBLIC_CONCIERGE_API_URL or NEXT_PUBLIC_API_URL must be set in environment variables'
        );
      }
      const httpClient = new AxiosHttpClient();
      this.instance = new TravelAssistantRepository(httpClient, baseUrl);
    }
    return this.instance;
  }

  /**
   * Create a new instance with custom configuration
   */
  static create(
    baseUrl: string,
    httpClient?: AxiosHttpClient
  ): ITravelAssistantRepository {
    const client = httpClient || new AxiosHttpClient();
    return new TravelAssistantRepository(client, baseUrl);
  }

  /**
   * Reset singleton instance (useful for testing)
   */
  static reset(): void {
    this.instance = null;
  }
}
